import * as Types from '../constants/actionTypes';

const defaultState = {
    isPending: false,
    carriersList: [],
    error: ''
}

export default (state = defaultState, action) => {
    switch (action.type) {
        /* List Carrier Details */
        case Types.CARRIERS_DETAIL_SUCCESS:
            return {
                ...state,
                carriersList: action.payload
            }
        /* Carrier Add reducers */
        case Types.CARRIERS_ADDED_SUCCESS:
            state.carriersList.push(action.payload)
            return {
                ...state
            }
        case Types.CARRIERS_DELETED_SUCCESS:
            const newList = state.carriersList.filter((carrier) => carrier.id !== action.payload)
            return {
                ...state,
                carriersList: newList,
                deletedStatus: action.payload
            }
        case Types.CARRIERS_UPDATED_SUCCESS:
            state.carriersList[action.updateIndex] = action.payload
            return {
                ...state
            }

        /* List Carrier Details without pagination . Dropdowns */
        case Types.ALL_CARRIERS_LIST:
            return {
                ...state,
                allCarriers: action.allCarriers
            }
        case Types.CARRIERS_ERROR:
            return {
                ...state,
                carrierError: action.carrierError
            }
        case Types.CARRIER_UPLOAD_ERROR:
            return {
                carrierUploadError: action.error
            }
        case Types.CARRIER_UPLOAD_SUCCESS:
            return {
                uploadSuccessmessage: action.payload
            }
        case Types.PACKAGING_CODE_SUCCESS:
            return {
                ...state,
                packagingCodeList: action.payload
            }
        case Types.PACKAGING_CODE_LIST:
            return {
                ...state,
                packagingCode: action.payload
            }
        case Types.PACKAGING_CODE_ERROR:
            return {
                packagingCodeError: action.error
            }
        case Types.CARRIER_INFO_COUNT_SUCCESS:
            return Object.assign({}, state, { carrierInfoCount: action.payload })
        default:
            return state
    }
}

